import { SavedReshipmentItem } from '.'
import { convertTitleCase } from '../../utils/common'

export default ({ data, error }) => {
  const noItems = Object.keys(data).length === 0

  if (error) {
    return <p className="cb-error-msg">Error retreiving saved items</p>
  }

  if (noItems) {
    return <p>You have not added any items to reship.</p>
  }

  return (
    <>
      {Object.keys(data).map(
        examDateType =>
          data[examDateType]?.length && (
            <Fragment key={examDateType}>
              <h3 style={{ marginTop: '8px', marginBottom: '5px' }}>
                {convertTitleCase(examDateType)}
              </h3>
              {data[examDateType].map(item => (
                <SavedReshipmentItem key={item.ancillaryCd} item={item} />
              ))}
            </Fragment>
          )
      )}
    </>
  )
}
